import 'hammerjs';
import {DOCUMENT} from '@angular/common';
import {Inject, Injectable, NgModule, NgZone} from '@angular/core';
import {
    EVENT_MANAGER_PLUGINS,
    EventManagerPlugin,
} from '@angular/platform-browser';

const HAMMER_EVENT_NAMES = new Set([
    'swipe',
    'swipeleft',
    'swiperight',
    'swipeup',
    'swipedown',
    'pan',
    'panstart',
    'panmove',
    'panend',
    'pancancel',
    'panleft',
    'panright',
    'panup',
    'pandown',
    'pinch',
    'pinchstart',
    'pinchmove',
    'pinchend',
    'pinchcancel',
    'pinchin',
    'pinchout',
    'press',
    'pressup',
    'rotate',
    'rotatestart',
    'rotatemove',
    'rotateend',
    'rotatecancel',
    'tap',
    'doubletap',
]);

/**
 * Angular 22 removed HammerModule. This is its event plugin: it routes the
 * Hammer gesture names (tap, panstart, ...) used in host listeners to hammerjs.
 */
@Injectable()
export class HammerGesturesPlugin extends EventManagerPlugin {
    constructor(
        @Inject(DOCUMENT) doc: Document,
        private zone: NgZone
    ) {
        super(doc);
    }

    public supports(eventName: string): boolean {
        return HAMMER_EVENT_NAMES.has(eventName.toLowerCase());
    }

    public addEventListener(
        element: HTMLElement,
        eventName: string,
        handler: (event: HammerInput) => void
    ): () => void {
        const name = eventName.toLowerCase();

        return this.zone.runOutsideAngular(() => {
            const manager = new Hammer(element);
            manager.get('pinch').set({enable: true});
            manager.get('rotate').set({enable: true});

            const callback = (event: HammerInput) =>
                this.zone.runGuarded(() => handler(event));
            manager.on(name, callback);

            return () => {
                manager.off(name, callback);
                manager.destroy();
            };
        });
    }
}

@NgModule({
    providers: [
        {
            provide: EVENT_MANAGER_PLUGINS,
            useClass: HammerGesturesPlugin,
            multi: true,
        },
    ],
})
export class HammerGesturesModule {}
